import React from 'react';
import classNames from 'classnames';
import DropdownItem from '../dropdowns/DropdownItem';
import DropdownButton from '../dropdowns/DropdownButton';

const FilterDistrictOpen = (props) => {

    const { toggleCongressDropdowns, congress, chooseDropdownItem, isMobile, districtInfo } = props;
    const propsValue = `congressDistrict-${congress.filterDistrict.congressDistrict}`;

    const StateDistrict = Object.keys(congress.districts).map((district, i) =>
        <DropdownItem
            func={chooseDropdownItem}
            districtInfo={congress.districts[district]}
            type="district"
            selectedItem={congress.selected.districtName}
        />,
    );

    return (
        <div>
            <DropdownButton
                name={congress.selected.districtName}
                callFunction={toggleCongressDropdowns}
                callVal={propsValue}
                chevron={congress.filterDistrict.congressDistrict ? 'up' : 'down'}
                isMobile={isMobile}
                districtInfo={districtInfo}
                id="district-filter"
                active={congress.selected.stateName !== 'State'}
                expanded={congress.filterDistrict.congressDistrict}
            />

            <div className={classNames('list-dropdown', {
                'open': congress.filterDistrict.congressDistrict,
            })}>
                <ul className="list-group">
                    {congress.districts.length !== 0 ? StateDistrict : ''}
                </ul>
            </div>
        </div>
    );
};

export default FilterDistrictOpen;
